<template>
  <faq-main :title="title" :items="items" />
</template>
<script setup lang="ts">
import FaqMain from '@/components/FAQ/FaqMain.vue';
import type { IFaqMenuBlock } from '@/components/FAQ/types';

interface IFaqPageProps {
  title: string;
  items: IFaqMenuBlock[];
}

defineProps<IFaqPageProps>();
</script>
